// Module
var code = "<div class=\"landing-page-info-section\">\n    <div class=\"tw-font-bold tw-text-4xl tw-text-grey-darkest landing-page-info-section-title\"\n         ng-class=\"$ctrl.headerClass\" ng-transclude=\"header\"></div>\n    <div class=\"tw-text-2xl tw-text-grey-darker-1\" ng-class=\"$ctrl.bodyContentClass\" ng-transclude=\"body\"></div>\n</div>\n";
// Exports
module.exports = code;